module.exports = __webpack_public_path__ + "img/humanImg1.b73b23a2.png";